module.exports = __webpack_public_path__ + "public/images/prizes/prize-2.5d882c3f8801764b89e7ac08c7530b97.jpg";